import * as React from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { InputClass } from '@sphinx/components-styles'
import * as classNames from 'classnames'

export interface TextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  autosize?: boolean
  invalid?: boolean
  value?: string
}

const getClassName = (invalid: boolean) => {
  return invalid ? InputClass.invalid : InputClass.valid
}

export const TextArea: React.FC<TextAreaProps> = React.forwardRef(
  function TextArea(
    {
      invalid,
      autosize,
      className,
      ...props
    }: Omit<TextAreaProps, 'ref' | 'aria-relevant'>,
    // aria-relevant types discrepancy with react-textarea-autosize
    ref: React.Ref<any>
  ) {
    return autosize ? (
      <TextareaAutosize
        className={classNames(getClassName(invalid), className)}
        ref={ref}
        style={{ overflowY: 'hidden' } as any}
        {...props}
      />
    ) : (
      <textarea
        className={classNames(getClassName(invalid), className)}
        ref={ref}
        {...props}
      />
    )
  }
)
